<template>
  <div class="">
    <a href="#" class="block no-underline fixed bg-black px-6 py-3 rounded-tl-lg rounded-tr-lg" 
    	style="width:160px;bottom:0;right:10px;z-index:100;"
      v-on:click.prevent="$modal.show('auto-save-modal')">

    	<div v-if="autoSaving" class="auto-save-spinner"></div>

    	<div class="inline-block text-white text-xs"
    		v-bind:class="{ flash: autoSaving }">
      	<div class="" v-if="autoSaving">
      		Auto-saving
      	</div>
      	<div v-else>
      		Auto-saving is on
      	</div>
      </div>

      <span class="inline-block bg-green-500 rounded-full p-1 ml-2"></span>
    </a>

    <AutoSaveModal></AutoSaveModal>
  </div>
</template>

<script>

  import AutoSaveModal  from "@/shared/components/modals/AutoSaveModal"

  export default {

    components : {
      AutoSaveModal
    },

  	props : {
  		autoSaving : {
				type    : Boolean,
				required: false,
				default : false
  		}
  	}

  }

</script>

<style scoped>
	.flash {
	  animation-name: flash;
	  animation-duration: 0.5s;
	  animation-timing-function: linear;
	  animation-iteration-count: infinite;
	  animation-direction: alternate;
	  animation-play-state: running;
	}

	@keyframes flash {
	  from {color: white;}
	  to {color: black;}
	}
</style>